import BlogLayout1Container from "../../../../components/pages/blog/blogPage/BlogLayout1";

const BlogLayout1 = () => {
  return <BlogLayout1Container />;
};

export default BlogLayout1;
